import { toCamel } from './../Util/SnakeCamelUtil';
import { PaymentDAO } from './../DAO/PaymentDAO';
import { BaseService } from './BaseService';

/**
 * PaymentService
 *
 * 請求関係のロジックサービス
 * DAOで取得したデータを操作等行い、View側に渡す。
 */
export class PaymentService extends BaseService {


	/**
	 * getPaymentList
	 * 請求一覧の取得
	 * @param userId ユーザーID
	 * @returns 請求一覧
	 */
	public async getPaymentList() {

		const dao = new PaymentDAO(this as BaseService);
		const ret = await dao.getPaymentList();

		return this.obj2Array(toCamel(ret));


	}

	/**
	 * getPaymentDetail
	 * 請求詳細の取得
	 * @param paymentId 請求ID
	 * @returns 請求詳細データ
	 */
	public async getPaymentDetail(paymentId: number) {

		const dao = new PaymentDAO(this as BaseService);
		const ret = await dao.getPaymentDetail(paymentId);

		const tmp: any = toCamel(ret);

		if (!tmp.epsilon) {
			return tmp;
		}

		// 設定値の日本語化
		switch (tmp.epsilon.state) {
			case '0':
			case 0:
				tmp.epsilon.stateStr = '決済未完了';
				break;
			case '1':
			case 1:
				tmp.epsilon.stateStr = '支払い済み';
				break;
			case '9':
			case 9:
				tmp.epsilon.stateStr = 'キャンセル';
				break;
			default:
				tmp.epsilon.stateStr = '決済未完了';
				break;
		}

		return tmp;

	}

}


// {
//     "lastUpdate": "2022-02-08 11:25:09",
//     "userMailAdd": "yuto-yamazaki@wellnest.co.jp",
//     "state": "1",
//     "creditTime": "2022-02-08 17:21:03",
//     "missionCode": "1",
//     "creditFlag": "0",
//     "itemPrice": "500",
//     "paymentCode": "1",
//     "itemCode": "11111",
//     "orderNumber": "45",
//     "stCode": "11000-0000-00000-00000-00000-00000-00000",
//     "memo1": "",
//     "itemName": "01",
//     "payTime": "1",
//     "userName": "山崎 悠渡",
//     "processCode": "2",
//     "keitai": "0",
//     "dueDate": "",
//     "cardStCode": "10",
//     "addInfo": "",
//     "userId": "10",
//     "memo2": ""
// }
